/*
 *   File : header.js
 *   Author : https://evoqins.com
 *   Description : Header component
 *   Version : 1.0.0
*/

// import packages
import { memo, Fragment } from "react";

// import components
import { useLocation, useNavigate } from "react-router-dom/dist";
import { Icon } from "../Icon";

// import styles
import styles from '../../Styles/Components/left-navigation.module.scss';


const MENU_ITEMS = [
    {
        name: "Home",
        link: "/",
        child_paths: ["/financial-freedom", "/financial-summary", "/orders", "/calculators", "/systematic-transactions", "/risk-profile", "/manage-bank", "/nominee", "/manage-kyc", "/reports", "/refer-earn", "/about-us", "/faq"],
        inactive: require("../../Assets/Images/Sidebar/home.png"),
        active: require("../../Assets/Images/Sidebar/home-active.png"),
    },
    {
        name: "Portfolio",
        link: "/portfolio",
        inactive: require("../../Assets/Images/Sidebar/portfolio.png"),
        active: require("../../Assets/Images/Sidebar/portfolio-active.png"),
    },
    {
        name: "Milestones",
        link: "/milestone",
        inactive: require("../../Assets/Images/Sidebar/lifegoals.png"),
        active: require("../../Assets/Images/Sidebar/lifegoals-active.png"),
    },
    {
        name: "Explore",
        link: "/explore",
        inactive: require("../../Assets/Images/Sidebar/explore.png"),
        active: require("../../Assets/Images/Sidebar/explore-active.png"),
    },
    {
        name: "Learn",
        link: "/resource",
        inactive: require("../../Assets/Images/Sidebar/educate.png"),
        active: require("../../Assets/Images/Sidebar/educate-active.png"),
    }
]


const LeftNavigation = (props) => {

    const navigate = useNavigate();
    const location = useLocation();

    return (
        <Fragment>
            <div
                data-bs-backdrop="static"
                data-bs-scroll="false"
                tabIndex="0"
                id="left-navigation-offcanvas"
                aria-labelledby="offcanvasWithBothOptionsLabel"
                className={`${props.type ? "offcanvas offcanvas-start px-2 w-auto pt-3 align-items-center outline-none" : "position-sticky top-0 padding-32px-top d-flex flex-column align-items-center outline-none"} `}>

                {/* Logo */}
                <img src={require("../../Assets/Images/Global/mintit-logo.png")}
                    alt="logo"
                    height={props.type ? 32 : 46}
                    width={"auto"}
                    draggable={false}
                    className="e-login-logo mb-4 px-2"
                    data-bs-dismiss={props.type && "offcanvas"}
                    onClick={() => {
                        if (location.pathname !== "/") {
                            navigate("/")
                        } else {
                            window.scrollTo(0, 0)
                        }
                    }} />
                {/* Menu list */}
                {
                    MENU_ITEMS.map((item, key) => {
                        const route_nodes = location.pathname.split("/");

                        // if array length more than 2 means detail page taking the 1st node from url 
                        const index_page = (route_nodes.length >= 2) ? `/${route_nodes[1]}` : location.pathname;
                        return (
                            // eslint-disable-next-line
                            <div key={key} data-bs-dismiss={props.type && "offcanvas"} className={`w-64px h-64px margin-12px-bottom text-center padding-10px-top padding-6px-bottom border-radius-10px ${index_page === item.link || item.child_paths && item.child_paths.includes(index_page) ? 'e-bg-lavender-blush' : styles.e_navigation_item}`}
                                onClick={() => {
                                    if (item.link !== index_page) {
                                        navigate(item.link)
                                    }
                                }}>
                                {/* eslint-disable-next-line */}
                                <img src={index_page === item.link || item.child_paths && item.child_paths.includes(index_page) ? item.active : item.inactive}
                                    alt={item.name}
                                    width={24}
                                    height={24}
                                    className="mb-1 d-md-flex d-none mx-auto" />
                                {/* eslint-disable-next-line */}
                                <img src={index_page === item.link || item.child_paths && item.child_paths.includes(index_page) ? item.active : item.inactive}
                                    alt={item.name}
                                    width={20}
                                    height={20}
                                    className="mb-1 d-md-none d-flex mx-auto" />
                                <p className="e-font-12 e-line-height-20 color-rebecca-purple e-montserrat-medium mb-0">{item.name}</p>
                            </div>
                        )
                    })
                }
                <Icon icon="close"
                    size={24}
                    id="offcanvas-close"
                    className="mx-auto mb-2 d-lg-none d-block e-social-icon"
                    data-bs-dismiss="offcanvas"
                    onClick={() => document.body.removeAttribute("style")} />


            </div>

        </Fragment>
    )
}
export default memo(LeftNavigation)